module.exports = __webpack_public_path__ + "static/media/动效.349d6745.gif";


//////////////////
// WEBPACK FOOTER
// ./src/pages/awards/images/动效.gif
// module id = 1192
// module chunks = 0